//import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined"
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined"
import  HealingOutlinedIcon  from "@mui/icons-material/HealingOutlined"
import CardGiftcardOutlinedIcon from "@mui/icons-material/CardGiftcardOutlined"

const FinanceMenu = {
    id: 'financesRoot',
    title: 'FINANCES',
    type: 'group',
    children: [
        // {
        //     id: 'bills',
        //     title: 'Bills',
        //     type: 'item',
        //     url: '/bills',
        //     breadcrumbs: false,
        //     icon: AttachMoneyOutlinedIcon
        // },
        {
            id: 'payments',
            title: 'Payments',
            type: 'item',
            url: '/payments',
            breadcrumbs: false,
            icon: PaymentOutlinedIcon
        },
        // {
        //     id: 'outstanding',
        //     title: 'Outstanding',
        //     type: 'item',
        //     url: '/outstanding',
        //     breadcrumbs: false,
        //     icon: PaymentOutlinedIcon
        // },
        {
            id: 'credit',
            title: 'Family Treatment Balance',
            type: 'item',
            url: '/credit/product',
            breadcrumbs: false,
            icon: HealingOutlinedIcon
        },
        {
            id: 'creditBalance',
            title: 'Family Account Records',
            type: 'item',
            url: '/credit/familybalance',
            breadcrumbs: false,
            icon: CardGiftcardOutlinedIcon
        }
        // {
        //     id: 'credits',
        //     title: 'Family Account Records',
        //     type: 'item',
        //     url: '/credits',
        //     breadcrumbs: false,
        //     icon: CardGiftcardOutlinedIcon
        // },
        // {
        //     id: 'historyCredit',
        //     title: 'Family Account Records',
        //     type: 'item',
        //     url: '/credit/family',
        //     breadcrumbs: false,
        //     icon: CardGiftcardOutlinedIcon
        // }
    ]
}

export default FinanceMenu
